import { OnDestroy, Directive } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppInjector } from '@shared/services/app-injector.service';
import { BaseComponent } from '@shared/components/base.component';
import { Subscription } from 'rxjs';
import { AuthorizationService } from '../../../../../components/auth/auth.service';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Error } from '@shared/interfaces/error.interface';

@Directive()
export class BaseAuthComponent extends BaseComponent implements OnDestroy {
  fb: UntypedFormBuilder;
  activatedRoute: ActivatedRoute;
  authService: AuthorizationService;
  form: UntypedFormGroup = new UntypedFormGroup({});
  someSubscriptions: Subscription = new Subscription();
  loading: boolean = false;
  layoutTitle: string = this.translate.instant('GLOBAL.welcome');
  socialAuthService: SocialAuthService;

  constructor() {
    super();
    const injector = AppInjector.getInjector();
    this.fb = injector.get(UntypedFormBuilder);
    this.activatedRoute = injector.get(ActivatedRoute);
    this.authService = injector.get(AuthorizationService);
    this.socialAuthService = injector.get(SocialAuthService);
  }

  get btnDisabled() {
    return this.loading || this.form.invalid;
  }

  get btnDisabledLogin() {
    return this.loading || this.form.invalid;
  }

  ngOnDestroy() {
    this.someSubscriptions.unsubscribe();
  }

  onAuthError(error: Error) {
    switch (error?.message) {
      case 'account_blocked': {
        this.toast.error(
          this.translate.instant('AUTH.account_is_blocked'),
          this.translate.instant('AUTH.login_error')
        );
        break;
      }
      case 'wrong_token_passed': {
        this.toast.error(
          this.translate.instant('AUTH.password_will_not_be_changed'),
          this.translate.instant('AUTH.resetting_password_cancel')
        );
        break;
      }
      case 'user_exists': {
        this.toast.error(
          this.translate.instant('AUTH.user_exists'),
          this.translate.instant('AUTH.login_error')
        );
        this.socialAuthService.signOut().then(() => {});
        break;
      }
      case 'wrong_username_or_password': {
        this.toast.error(
          this.translate.instant('AUTH.wrong_username_or_password'),
          this.translate.instant('AUTH.login_error')
        );
        break;
      }
      case 'account_is_blocked_by_administration': {
        this.toast.error(
          this.translate.instant('AUTH.account_is_blocked_by_administration'),
          this.translate.instant('AUTH.login_error')
        );
        break;
      }
    }
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
}
